import { MoneyFormatter } from "../../MoneyFormatter";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { LogGroup } from "../.././MyHelpers";
import { BetMultiplierRewardOption } from "./BetMultiplierRewardOption";
import { JackpotRewardOption, } from "./JackpotRewardOption";
import { IRewardOption } from "./ScatterRandomAward";
import { AwardType, BetMultiplierAwardOption, CreditAwardOption, JackpotAwardOption } from "../../api";
import { CreditRewardOption } from "./CreditRewardOption";

export interface IRewardOptionConfig
{
    readonly AwardType: AwardType;
    readonly AwardName: string;
    //readonly index: number;
}

export interface RewardOptionParams
{
    readonly logGroup: LogGroup;
	readonly resid: ResourceIdentifier;
}

export interface RewardColor
{
    color: string;
    coloroutherStroke: string;
    colorinnerStroke: string;
}

export interface IRewardOptionFactory
{
    CreateRewardOption(params: RewardOptionParams, config: IRewardOptionConfig, color: RewardColor): IRewardOption;
}

export class RewardOptionFactory implements IRewardOptionFactory
{
    public CreateRewardOption(params: RewardOptionParams, config: IRewardOptionConfig, color: RewardColor): IRewardOption
    {
        switch(config.AwardType)
        {
            case AwardType.Jackpot:
                return new JackpotRewardOption(params, config as JackpotAwardOption, color);
            break;
            
            case AwardType.BetMultiplier:
                return new BetMultiplierRewardOption(params, config as BetMultiplierAwardOption, color);
            break;

            case AwardType.Credit:
                return new CreditRewardOption(params, config as CreditAwardOption, color);
            break;



            default:
                throw `Unimplemented Reward option type ${config.AwardType}`;
        }
    }
}